export const HoloPanel = ({ children, gold = false, className = "", testId }) => (
  <section className={`holo-panel${gold ? " gold" : ""} ${className}`} data-testid={testId}>
    {children}
  </section>
);